import { render, staticRenderFns } from "./SyncManager.vue?vue&type=template&id=1f210946&"
import script from "./SyncManager.vue?vue&type=script&lang=js&"
export * from "./SyncManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports